// extracted by mini-css-extract-plugin
export default {"invoice-table":"style_invoice-table__3NkxP","invoiceTable":"style_invoice-table__3NkxP"};